import React, { useState } from 'react';

import UnifiedViewNotes from './UnifiedViewNotes';
import UnifiedEditNotes from './UnifiedEditNotes';

const UnifiedNotes = ({
  id,
  admin_note,
  customer_diagnostic_note,
  customer_schedule_note,
  customer_note,
  customer_tire_note,
  vehicle_service_requirements_note,
  customer_home_additional_note,
  key_exchange_note,
  technician_note,
  payment_note,
  st_company_name,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  return (
    <>
      {!isEditing ? (
        <UnifiedViewNotes
          admin_note={admin_note}
          customer_diagnostic_note={customer_diagnostic_note}
          customer_schedule_note={customer_schedule_note}
          customer_note={customer_note}
          customer_tire_note={customer_tire_note}
          vehicle_service_requirements_note={vehicle_service_requirements_note}
          customer_home_additional_note={customer_home_additional_note}
          key_exchange_note={key_exchange_note}
          technician_note={technician_note}
          payment_note={payment_note}
          setIsEditing={setIsEditing}
          companyname={st_company_name}
        />
      ) : (
        <UnifiedEditNotes
          id={id}
          admin_note={admin_note}
          customer_diagnostic_note={customer_diagnostic_note}
          customer_schedule_note={customer_schedule_note}
          customer_note={customer_note}
          customer_tire_note={customer_tire_note}
          vehicle_service_requirements_note={vehicle_service_requirements_note}
          customer_home_additional_note={customer_home_additional_note}
          key_exchange_note={key_exchange_note}
          technician_note={technician_note}
          payment_note={payment_note}
          setIsEditing={setIsEditing}
          companyname={st_company_name}
        />
      )}
    </>
  );
};

export default UnifiedNotes;
